// extracted by mini-css-extract-plugin
export var currentStep = "_dn-2";
export var nodeCard = "_dn-0";
export var pathHighlighted = "_dn-1";